import publicConfig from "@/config/public";

import useDomainCountryCode from "./useDomainCountryCode";

const { leaflyDomain, leaflyCaDomain } = publicConfig;

const getDomainFromContext = (countryCode: string) =>
  countryCode === "CA" ? leaflyCaDomain : leaflyDomain;

const useDomain = () => getDomainFromContext(useDomainCountryCode());

export default useDomain;
